import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Classes from "./components/Classes";
import Levels from "./components/Levels";
import About from "./components/About";
import Community from "./components/Community";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import BookingDialog from "./components/BookingDialog";
import ClassesPage from "./pages/ClassesPage";
import ProductsPage from "./pages/ProductsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";

const Home = () => {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = () => setBookingOpen(true);

  return (
    <div className="App">
      <Header onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        <Classes onBook={openBooking} />
        <Levels />
        <About onBook={openBooking} />
        <Community />
        <FinalCTA onBook={openBooking} />
      </main>
      <Footer />
      <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/classes" element={<ClassesPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
